import { initNewRelic } from './newrelic'
initNewRelic()
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SessionProvider } from 'contexts/Session'
import { LocalForageProvider } from 'contexts/LocalForage'
import { ModalContextProvider } from 'contexts/Modal'

import { waitOnCache } from 'lib/graphql/client'

import App from './App.js'

const Skeleton = () => (
  <BrowserRouter>
    <LocalForageProvider>
      <ModalContextProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ModalContextProvider>
    </LocalForageProvider>
  </BrowserRouter>
)
if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
    })
  }
} else {
  // Make sure service workers are unregistered in dev
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
  }
}

waitOnCache.then(() => {
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(<Skeleton />)
})
